import styled from "styled-components";

const StyledWebviewFooter = styled.footer`
  padding-block: 10rem;
`;

const FooterWebview = () => {
  return <StyledWebviewFooter />;
};

export default FooterWebview;
